import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import Ajax from "base/Ajax";

import "jquery-serializejson";
import Page from "webPage/Page";
import {loadGoogleMap} from "./util/map";
import handleVideos from "./util/handleVideos";
import handleGalleryGridElements from "./blocks/GalleryGrid";
import handleSearchForm from "./util/handleSearchForm";
import handleNavigation from "./util/handleNavigation";
import handleMachineGallery from "./util/handleMachineGallery";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    Page.init();

    handleVideos();
    handleGalleryGridElements();
    handleSearchForm();
    handleNavigation();
    handleMachineGallery();

    $('body').on('click', '.js-toggle-categories', function(){
       $('.js-categories').slideToggle();
    }).on('click', '.js-toggle-nav', function(){
        $('.js-sidebar-nav').slideToggle();
    });

    if ($('.js-google-map').length > 0) {
        $('.js-google-map').each(function(index, $el){
            loadGoogleMap($el);
        });

    }
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
window.Ajax = Ajax;
